import { render, staticRenderFns } from "./taskpackge.vue?vue&type=template&id=05c5707c&"
import script from "./taskpackge.vue?vue&type=script&lang=js&"
export * from "./taskpackge.vue?vue&type=script&lang=js&"
import style0 from "./taskpackge.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports